import { roleDisplayInfo } from "~/components/layout/utils/roleUtils";
import { cn } from "~/lib/utils";
import { useProfileStore } from "~/store/profileStore";
import { UserRole } from "~/types/user";

interface SidebarLogoProps {
  userRole: UserRole;
}

export function SidebarLogo({ userRole }: SidebarLogoProps) {
  const { name, lastname, email } = useProfileStore();

  return (
    <div className="p-6">
      <div className="flex flex-col items-center">
        <img src="/aliace-logo.jpg" alt="ALIACE Logo" className="mb-3 h-14" />
        <div
          className={cn(
            "mb-3 mt-1 rounded-full px-4 py-1 text-sm font-medium text-white",
            roleDisplayInfo[userRole].color
          )}
        >
          Portal de {roleDisplayInfo[userRole].name}
        </div>

        {/* User profile information */}
        <div className="mt-2 flex w-full flex-col items-center">
          {/* Display full name instead of avatar */}
          <div className="mb-2 text-center text-lg font-semibold text-gray-800">
            {name && lastname ? `${name} ${lastname}` : email || "Usuario"}
          </div>

          {email && (
            <div className="w-full truncate text-center text-xs text-gray-500">
              {email}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
